import { useTranslation } from 'react-i18next';
import { QTooltip, QBox, QIcon } from '@qualio/ui-components';

export const SharedWithIcon = ({
  count,
  dataCy,
}: {
  count: number;
  dataCy: string;
}) => {
  const { t } = useTranslation();
  const tooltip = t('tooltips.sharedWithCompanies', { count });

  return (
    <QTooltip label={tooltip}>
      <QBox
        as="span"
        display="inline-flex"
        flexShrink={0}
        role="img"
        aria-label={tooltip}
        data-cy={dataCy}
      >
        <QIcon iconName="Share2" color="blue.400" />
      </QBox>
    </QTooltip>
  );
};
